var exports = {
  "kL": "ChannelWebhooksTab.module__container___MFdGNE",
  "wx": "ChannelWebhooksTab.module__header___MFdGNE",
  "h_": "ChannelWebhooksTab.module__description___MFdGNE",
  "UD": "ChannelWebhooksTab.module__buttonContainer___MFdGNE",
  "dc": "ChannelWebhooksTab.module__spinnerContainer___MFdGNE",
  "Xb": "ChannelWebhooksTab.module__messageBox___MFdGNE",
  "PQ": "ChannelWebhooksTab.module__webhooksList___MFdGNE",
  "wp": "ChannelWebhooksTab.module__followedSection___MFdGNE",
  "Gf": "ChannelWebhooksTab.module__sectionTitle___MFdGNE",
  "yV": "ChannelWebhooksTab.module__sectionDescription___MFdGNE",
};

module.exports = exports;
